import React, { useState } from 'react';
import './SubscribeForm.css';

const SubscribeForm = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setStatus('Please enter your email address');
      return;
    }

    if (!email.includes('@')) {
      setStatus('Please enter a valid email address');
      return;
    }

    setIsLoading(true);
    setStatus('');

    try {
      // Simulate API call delay
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // For now, just show success message
      setStatus('Thank you for subscribing! Welcome to the magic! ✨');
      setEmail('');
    } catch (error) {
      console.error('Subscription error:', error);
      setStatus('Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section id="subscribe" className="subscribe-section">
      <div className="container">
        <div className="subscribe-content">
          <h2>Join Our Magical Newsletter</h2>
          <p className="subscribe-description">
            Join our magical monthly newsletter for travel deals & park tips!
          </p>
          
          <form onSubmit={handleSubmit} className="subscribe-form">
            <div className="form-group">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
                className="email-input"
                disabled={isLoading}
                required
              />
              <button 
                type="submit" 
                className="subscribe-button"
                disabled={isLoading}
              >
                {isLoading ? 'Subscribing...' : 'Subscribe'}
              </button>
            </div>
            
            {status && (
              <div className={`status-message ${status.includes('Thank you') ? 'success' : 'error'}`}>
                {status}
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default SubscribeForm; 